export default "__VITE_ASSET__BZZALhLN__"